import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJoin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.05 12.9809L2 11.9103L5.75 8.08677V2.94412L3.81875 4.91324L2.75 3.82353L6.5 0L10.2687 3.84265L9.2 4.93235L7.25 2.94412V8.69853L3.05 12.9809ZM9.95 13L7.55 10.5721L8.61875 9.48235L11 11.9294L9.95 13Z",
		fill: "#7B61FF"
	})]
});
const ForwardRef = forwardRef(SvgJoin);
export { ForwardRef as ReactComponent };
